<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      红树湾南站<br>
站点介绍<br>
红树湾南站位于白石四道与深湾二路交界处，北侧为未开发用地，南侧招商银行工地，南侧为深圳车管所白石洲考场（已拆除），东侧为未开发用地，西侧毗邻深湾汇云中心。站厅两侧与全线标准统一材料、规格、安装形式，立柱之间区域，采用格栅形式突出重点。通过站厅、站台地面节奏线造型、站台的与导向共性元素结合的座椅等元素以及天花强调功能的裸露形式，呼应和谐主题，整个空间协调统一。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:09	23:48	9号线	3分50秒	5分55秒<br>
文锦	06:30	23:21	9号线	3分50秒	5分55秒<br>
岗厦北	06:19	00:27	11号线	4分钟	6分32秒<br>
碧头	06:31	23:41	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:10	23:48	9号线	4分25秒	5分55秒<br>
文锦	06:30	23:21	9号线	4分25秒	5分55秒<br>
岗厦北	06:19	00:27	11号线	4分34秒	6分钟<br>
碧头	06:31	23:41	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:09	00:48	9号线	4分钟	5分55秒<br>
文锦	06:30	00:21	9号线	4分钟	5分55秒<br>
岗厦北	06:19	00:27	11号线	4分37秒	6分钟<br>
碧头	06:31	23:41	11号线	4分37秒	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
白石四道南侧（西）、深湾二路西侧、深湾街心公园、深圳市海滨实验小学、红树西岸<br><br>
B出入口:<br>
白石四道南侧（东）<br><br>
C出入口:<br>
白石四道北侧（东）<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 红树湾南地铁站<br>
M561<br><br>
C出入口:<br>
公交站名： 红树湾南地铁站<br>
M561<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>